import React, { useState } from 'react';
import Constant from '../Components/Utils/Constant';
 

// --- FIX 2: Added 'selectedSubscription' to the component's props
const PaymentGatewayModal = ({ user, subscriptionAmount, onClose, selectedSubscription }) => {
  const [loadingGateway, setLoadingGateway] = useState('');

  const handlePayment = (gateway) => {
    const userId = user?._id || user?.id;
    if (!userId) {
      alert("User ID missing. Please create user again.");
      return;
    }
    if (!selectedSubscription) {
      alert("Subscription plan missing. Please select a plan again.");
      return;
    }

    setLoadingGateway(gateway);
    const nextUrl = `${Constant.BASE_URL}/payment/start?gateway=${encodeURIComponent(gateway)}&subscriptionId=${encodeURIComponent(selectedSubscription)}&userId=${encodeURIComponent(userId)}`;
    window.location.href = nextUrl;
  };

  const isLoading = (gateway) => loadingGateway === gateway;

  const labelForGateway = (gateway, label) => {
    if (isLoading(gateway)) return "Processing...";
    return label;
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
      <div className="bg-white p-8 rounded-lg shadow-xl w-full max-w-md">
        <h2 className="text-2xl font-bold mb-6 text-center">Choose Payment Method</h2>
        
        <div className="space-y-4">
          {/* PhonePe Option */}
          <button
            onClick={() => handlePayment('phonepe')}
            disabled={Boolean(loadingGateway)}
            className="w-full flex items-center justify-center p-4 border rounded-lg hover:bg-gray-100 transition duration-200 disabled:opacity-50"
          >
            <span className="text-lg font-semibold">
              {labelForGateway('phonepe', 'Pay with PhonePe')}
            </span>
          </button>

          {/* Cashfree Option */}
          <button
            onClick={() => handlePayment('cashfree')}
            className="w-full px-4 py-2 text-white bg-blue-600 rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-opacity-50"
            disabled={Boolean(loadingGateway)}
          >
            {labelForGateway('cashfree', 'Pay with Cashfree')}
          </button>

          <button
            onClick={() => handlePayment('easebuzz')}
            className="w-full px-4 py-2 text-white bg-emerald-600 rounded-md hover:bg-emerald-700 focus:outline-none focus:ring-2 focus:ring-emerald-500 focus:ring-opacity-50"
            disabled={Boolean(loadingGateway)}
          >
            {labelForGateway('easebuzz', 'Pay with Easebuzz')}
          </button>
        </div>

        <div className="mt-6 text-center">
            <button 
              onClick={!loadingGateway ? onClose : undefined} 
              className="text-gray-500 hover:text-gray-700"
            >
              Cancel
            </button>
        </div>
      </div>
    </div>
  );
};

export default PaymentGatewayModal;